// Messages for portal/Webhooks — the standalone customer webhooks page
// (auto-merged into the i18n catalog by lib/i18n.ts). Rows + modal reuse the
// existing portal.developers.webhooks.* / portal.add_webhook.* keys; the
// test/delivery/secret UI mirrors the operator webhooks screen.
export const en = {
  'portal.webhooks.head': 'Webhooks — Portal',
  'portal.webhooks.title': 'Webhooks',
  'portal.webhooks.desc':
    'Subscribe your systems to events on your own shipments, quotes, and invoices.',
  'portal.webhooks.test': 'Test',
  'portal.webhooks.testing': 'Testing…',
  'portal.webhooks.status.active': 'Active',
  'portal.webhooks.status.disabled': 'Disabled',
  'portal.webhooks.consecutive_failures': '{count} consecutive failures',
  'portal.webhooks.secret': 'secret',
  'portal.webhooks.secret_title': 'Signing secret',
  'portal.webhooks.secret_notice_before':
    "Copy this signing secret now — it won't be shown again. Verify the",
  'portal.webhooks.secret_notice_after': 'header on every delivery with it.',
  'portal.webhooks.copy': 'Copy',
  'portal.webhooks.copied': 'Copied',
  'portal.webhooks.deliveries': 'Recent deliveries',
  'portal.webhooks.no_deliveries': 'No deliveries yet.',
  'portal.webhooks.col.event': 'Event',
  'portal.webhooks.col.state': 'State',
  'portal.webhooks.col.status': 'Status',
  'portal.webhooks.col.attempts': 'Attempts',
  'portal.webhooks.col.when': 'When',
  'portal.webhooks.state.pending': 'Pending',
  'portal.webhooks.state.delivered': 'Delivered',
  'portal.webhooks.state.failed': 'Failed',
  'portal.webhooks.replay': 'Replay',
}

export const zhTW = {
  'portal.webhooks.head': 'Webhook — 客戶入口',
  'portal.webhooks.title': 'Webhook',
  'portal.webhooks.desc': '讓您的系統訂閱您自身貨件、報價與發票的事件。',
  'portal.webhooks.test': '測試',
  'portal.webhooks.testing': '測試中…',
  'portal.webhooks.status.active': '啟用中',
  'portal.webhooks.status.disabled': '已停用',
  'portal.webhooks.consecutive_failures': '連續 {count} 次失敗',
  'portal.webhooks.secret': '密鑰',
  'portal.webhooks.secret_title': '簽署密鑰',
  'portal.webhooks.secret_notice_before':
    '請立即複製此簽署密鑰 — 之後將不會再顯示。請以它驗證每次傳送的',
  'portal.webhooks.secret_notice_after': '標頭。',
  'portal.webhooks.copy': '複製',
  'portal.webhooks.copied': '已複製',
  'portal.webhooks.deliveries': '最近傳送',
  'portal.webhooks.no_deliveries': '尚無傳送紀錄。',
  'portal.webhooks.col.event': '事件',
  'portal.webhooks.col.state': '狀態',
  'portal.webhooks.col.status': '回應碼',
  'portal.webhooks.col.attempts': '嘗試次數',
  'portal.webhooks.col.when': '時間',
  'portal.webhooks.state.pending': '處理中',
  'portal.webhooks.state.delivered': '已送達',
  'portal.webhooks.state.failed': '失敗',
  'portal.webhooks.replay': '重送',
}
